/* ==========================================================================
   COFFAO — Refonte Torréfacteurs
   assets/coffao-torrefacteurs.js  (sans dépendance ; Leaflet chargé à la demande)
   1. Hub : recherche, filtres, panneau mobile, carte, compteurs, URL partageable
   2. Fiche : sommaire actif au scroll + infos repliées sur mobile
   Le contenu (cartes, textes) est déjà dans le HTML servi : ce script ne fait
   que masquer/afficher. Sans JS, la page reste complète.
   ========================================================================== */
(function () {
  "use strict";

  /* ------------------------------------------------------------------ */
  /* 1. HUB                                                              */
  /* ------------------------------------------------------------------ */
  var root = document.querySelector("[data-tf-directory]");
  if (root) initHub(root);

  function initHub(root) {
    var LEAFLET_CSS = "https://unpkg.com/leaflet@1.9.4/dist/leaflet.css";
    var LEAFLET_JS = "https://unpkg.com/leaflet@1.9.4/dist/leaflet.js";
    var listEl = root.querySelector("[data-tf-list]");
    var emptyEl = root.querySelector("[data-tf-empty]");
    var mapEl = root.querySelector("[data-tf-map]");
    var countEl = root.querySelector("[data-tf-count-visible]");
    var countLabelEl = root.querySelector("[data-tf-count-label]");
    var sheetCountEl = root.querySelector("[data-tf-sheet-count]");
    var filterCountEl = root.querySelector("[data-tf-filter-count]");
    var clearEl = root.querySelector("[data-tf-clear]");
    var searchEl = root.querySelector("[data-tf-search]");
    var originEl = root.querySelector("[data-tf-origin]");
    var sheetEl = root.querySelector("[data-tf-sheet]");
    var filterBtn = root.querySelector("[data-tf-filter-open]");
    var KEYS = ["region", "style", "eng", "flag", "orig"];
    var state = { q: "", region: [], style: [], eng: [], flag: [], orig: [], view: "list" };
    var map = null, markerLayer = null, leafletLoading = null, lastFocus = null;

    function norm(s) {
      return (s || "").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    }
    function cards() { return listEl ? listEl.querySelectorAll("[data-tf-card]") : []; }
    function list(card, attr) { return (card.getAttribute(attr) || "").split(",").map(function (x) { return x.trim(); }).filter(Boolean); }

    /* Chargement des pages suivantes (> 50 fiches) */
    function loadRemaining() {
      var next = root.getAttribute("data-tf-next-page");
      if (!next) return Promise.resolve();
      return fetch(next, { headers: { "X-Requested-With": "fetch" } })
        .then(function (r) { return r.ok ? r.text() : ""; })
        .then(function (html) {
          if (!html) { root.setAttribute("data-tf-next-page", ""); return; }
          var tmp = document.createElement("div");
          tmp.innerHTML = html;
          var incoming = tmp.querySelectorAll("[data-tf-card]");
          for (var i = 0; i < incoming.length; i++) listEl.appendChild(incoming[i]);
          var more = tmp.querySelector("[data-tf-next-page]");
          root.setAttribute("data-tf-next-page", more ? more.getAttribute("data-tf-next-page") : "");
          if (more) return loadRemaining();
        })
        .catch(function () { root.setAttribute("data-tf-next-page", ""); });
    }

    /* Règle : OU à l'intérieur d'un groupe (région, style), ET entre groupes.
       Engagements et « dans nos box » : chaque case cochée est exigée. */
    function matches(card) {
      if (state.q && norm(card.getAttribute("data-tf-haystack")).indexOf(norm(state.q)) === -1) return false;
      if (state.region.length && state.region.indexOf(card.getAttribute("data-tf-region")) === -1) return false;
      if (state.style.length && state.style.indexOf(card.getAttribute("data-tf-style")) === -1) return false;
      var eng = list(card, "data-tf-eng");
      for (var i = 0; i < state.eng.length; i++) if (eng.indexOf(state.eng[i]) === -1) return false;
      if (state.flag.indexOf("partner") !== -1 && card.getAttribute("data-tf-partner") !== "1") return false;
      if (state.orig.length) {
        var o = list(card, "data-tf-orig").map(norm), ok = false;
        for (var j = 0; j < state.orig.length; j++) if (o.indexOf(norm(state.orig[j])) !== -1) ok = true;
        if (!ok) return false;
      }
      return true;
    }
    function activeCount() {
      var n = 0;
      KEYS.forEach(function (k) { n += state[k].length; });
      return n;
    }

    function render() {
      var all = cards(), visible = [];
      for (var i = 0; i < all.length; i++) {
        var ok = matches(all[i]);
        all[i].hidden = !ok;
        if (ok) visible.push(all[i]);
      }
      var n = visible.length;
      if (countEl) countEl.textContent = n;
      if (countLabelEl) countLabelEl.textContent = n > 1 ? "torréfacteurs" : "torréfacteur";
      if (sheetCountEl) sheetCountEl.textContent = n;
      var nf = activeCount();
      if (filterCountEl) { filterCountEl.textContent = nf || ""; filterCountEl.setAttribute("data-z", nf); }
      if (clearEl) clearEl.classList.toggle("tf-hidden", !(nf || state.q));
      if (emptyEl) emptyEl.classList.toggle("tf-hidden", n > 0 || state.view === "map");
      if (listEl) listEl.classList.toggle("tf-hidden", n === 0 || state.view === "map");
      if (mapEl) mapEl.classList.toggle("tf-hidden", state.view !== "map");
      if (state.view === "map") drawMap(visible);
      syncUrl();
    }

    function syncControls() {
      var chips = root.querySelectorAll("[data-tf-chip]");
      for (var i = 0; i < chips.length; i++) {
        var k = chips[i].getAttribute("data-tf-key"), v = chips[i].getAttribute("data-tf-value");
        chips[i].setAttribute("aria-pressed", state[k] && state[k].indexOf(v) !== -1 ? "true" : "false");
      }
      if (originEl) originEl.value = state.orig[0] || "";
      if (searchEl && searchEl.value !== state.q) searchEl.value = state.q;
    }

    root.addEventListener("click", function (e) {
      var chip = e.target.closest("[data-tf-chip]");
      if (!chip) return;
      var k = chip.getAttribute("data-tf-key"), v = chip.getAttribute("data-tf-value");
      var i = state[k].indexOf(v);
      if (i === -1) state[k].push(v); else state[k].splice(i, 1);
      syncControls();
      render();
      /* Tampon région cliqué hors de l'annuaire : on y amène l'utilisateur */
      if (chip.classList.contains("tf-stamp")) {
        var target = document.getElementById("annuaire");
        if (target) target.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    });

    if (searchEl) {
      var t;
      searchEl.addEventListener("input", function (e) {
        clearTimeout(t);
        var val = e.target.value;
        t = setTimeout(function () { state.q = val; render(); }, 150);
      });
    }
    if (originEl) {
      originEl.addEventListener("change", function () {
        state.orig = originEl.value ? [originEl.value] : [];
        syncControls();
        render();
      });
    }

    function resetAll() {
      state.q = "";
      KEYS.forEach(function (k) { state[k] = []; });
      syncControls();
      render();
    }
    var resets = root.querySelectorAll("[data-tf-reset]");
    for (var r = 0; r < resets.length; r++) resets[r].addEventListener("click", resetAll);

    /* Panneau mobile */
    function openSheet() {
      if (!sheetEl) return;
      lastFocus = document.activeElement;
      sheetEl.classList.add("is-open");
      document.body.style.overflow = "hidden";
      var first = sheetEl.querySelector("[data-tf-sheet-close], [data-tf-chip]");
      if (first) first.focus();
    }
    function closeSheet() {
      if (!sheetEl || !sheetEl.classList.contains("is-open")) return;
      sheetEl.classList.remove("is-open");
      document.body.style.overflow = "";
      (lastFocus || filterBtn || document.body).focus();
    }
    if (filterBtn) filterBtn.addEventListener("click", openSheet);
    if (sheetEl) {
      sheetEl.addEventListener("click", function (e) { if (e.target.closest("[data-tf-sheet-close]")) closeSheet(); });
      sheetEl.addEventListener("keydown", function (e) {
        if (e.key === "Escape") { closeSheet(); return; }
        if (e.key !== "Tab") return;
        var f = sheetEl.querySelectorAll("button, select, [href], input");
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      });
    }

    /* Liste / carte */
    var viewBtns = root.querySelectorAll("[data-tf-view]");
    for (var v = 0; v < viewBtns.length; v++) {
      viewBtns[v].addEventListener("click", function (e) {
        state.view = e.currentTarget.getAttribute("data-tf-view");
        for (var k = 0; k < viewBtns.length; k++) viewBtns[k].setAttribute("aria-pressed", viewBtns[k] === e.currentTarget ? "true" : "false");
        if (state.view === "map") ensureLeaflet().then(render); else render();
      });
    }
    function ensureLeaflet() {
      if (window.L) return Promise.resolve();
      if (leafletLoading) return leafletLoading;
      leafletLoading = new Promise(function (resolve) {
        var css = document.createElement("link");
        css.rel = "stylesheet"; css.href = LEAFLET_CSS;
        document.head.appendChild(css);
        var js = document.createElement("script");
        js.src = LEAFLET_JS; js.onload = resolve; js.onerror = resolve;
        document.head.appendChild(js);
      });
      return leafletLoading;
    }
    function esc(s) {
      return String(s || "").replace(/[&<>"']/g, function (c) {
        return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
      });
    }
    function drawMap(visible) {
      if (!window.L || !mapEl) return;
      if (!map) {
        map = window.L.map(mapEl, { scrollWheelZoom: false }).setView([46.6, 2.4], 5);
        window.L.tileLayer("https://tile.openstreetmap.org/{z}/{x}/{y}.png", {
          maxZoom: 19, attribution: "&copy; contributeurs OpenStreetMap"
        }).addTo(map);
        markerLayer = window.L.layerGroup().addTo(map);
      }
      markerLayer.clearLayers();
      var bounds = [];
      for (var i = 0; i < visible.length; i++) {
        var lat = parseFloat(visible[i].getAttribute("data-tf-lat"));
        var lng = parseFloat(visible[i].getAttribute("data-tf-lng"));
        if (isNaN(lat) || isNaN(lng)) continue;
        var partner = visible[i].getAttribute("data-tf-partner") === "1";
        var marker = window.L.circleMarker([lat, lng], {
          radius: 9, weight: 3, color: "#FFFDF8", fillOpacity: 1,
          fillColor: partner ? "#F76F29" : "#054F05"
        });
        marker.bindPopup(
          "<strong>" + esc(visible[i].getAttribute("data-tf-name")) + "</strong><br>" +
          esc(visible[i].getAttribute("data-tf-where")) +
          (partner ? "<br>Dans nos box" : "") +
          '<br><a href="' + esc(visible[i].getAttribute("data-tf-url")) + '">Voir la fiche</a>'
        ).addTo(markerLayer);
        bounds.push([lat, lng]);
      }
      if (bounds.length) map.fitBounds(bounds, { padding: [30, 30], maxZoom: 12 });
      setTimeout(function () { map.invalidateSize(); }, 60);
    }

    /* Compteurs (tampons + carnet) calculés sur toutes les cartes chargées */
    function fillCounts() {
      var all = cards(), tally = {}, regions = {}, partners = 0;
      function bump(k) { tally[k] = (tally[k] || 0) + 1; }
      for (var i = 0; i < all.length; i++) {
        var c = all[i];
        var s = c.getAttribute("data-tf-style"); if (s) bump("style:" + s);
        var rg = c.getAttribute("data-tf-region"); if (rg) { bump("region:" + rg); regions[rg] = 1; }
        list(c, "data-tf-eng").forEach(function (e) { bump("eng:" + e); });
        if (c.getAttribute("data-tf-partner") === "1") { bump("flag:partner"); partners++; }
      }
      var slots = root.querySelectorAll("[data-tf-count]");
      for (var k = 0; k < slots.length; k++) {
        var n = tally[slots[k].getAttribute("data-tf-count")] || 0;
        slots[k].textContent = n ? n + " torréf." : "";
      }
      var tot = root.querySelector("[data-tf-total]");
      if (tot) tot.textContent = all.length;
      var tp = root.querySelector("[data-tf-total-partner]");
      if (tp) tp.textContent = partners;
      var tr = root.querySelector("[data-tf-total-regions]");
      if (tr) tr.textContent = Object.keys(regions).length;
    }

    /* URL partageable : ?q=&region=&style=&eng=&box=1&orig= */
    function syncUrl() {
      if (!window.history || !history.replaceState) return;
      var p = new URLSearchParams();
      if (state.q) p.set("q", state.q);
      ["region", "style", "eng", "orig"].forEach(function (k) { if (state[k].length) p.set(k, state[k].join(",")); });
      if (state.flag.indexOf("partner") !== -1) p.set("box", "1");
      var qs = p.toString();
      history.replaceState(null, "", qs ? location.pathname + "?" + qs + location.hash : location.pathname + location.hash);
    }
    function readUrl() {
      var p = new URLSearchParams(location.search);
      state.q = p.get("q") || "";
      ["region", "style", "eng", "orig"].forEach(function (k) { state[k] = (p.get(k) || "").split(",").filter(Boolean); });
      state.flag = p.get("box") === "1" ? ["partner"] : [];
    }

    readUrl();
    syncControls();
    render();
    fillCounts();
    loadRemaining().then(function () { fillCounts(); render(); });
  }

  /* ------------------------------------------------------------------ */
  /* 2. FICHE                                                            */
  /* ------------------------------------------------------------------ */
  var fiche = document.querySelector("[data-tf-fiche]");
  if (fiche) initFiche(fiche);

  function initFiche(fiche) {
    /* Infos pratiques : ouvertes sur desktop, repliées sur mobile */
    var infos = fiche.querySelector("[data-tf-infos]");
    if (infos && window.matchMedia("(max-width: 880px)").matches) infos.removeAttribute("open");

    /* Sommaire : entrée active selon la section visible */
    var links = fiche.querySelectorAll(".tf-toc .cf-sommaire a[href^='#']");
    if (!links.length || !("IntersectionObserver" in window)) return;
    var sections = [], byId = {};
    for (var i = 0; i < links.length; i++) {
      var id = decodeURIComponent(links[i].getAttribute("href").slice(1));
      var el = document.getElementById(id);
      if (el) { sections.push(el); byId[id] = i; }
    }
    function setActive(idx) {
      for (var j = 0; j < links.length; j++) {
        links[j].classList.toggle("is-active", j === idx);
        links[j].classList.toggle("is-past", j < idx);
        if (j === idx) links[j].setAttribute("aria-current", "true"); else links[j].removeAttribute("aria-current");
      }
      var tocScroll = links[idx] && links[idx].closest(".cf-sommaire");
      if (tocScroll && tocScroll.scrollWidth > tocScroll.clientWidth) {
        tocScroll.scrollTo({ left: links[idx].offsetLeft - 20, behavior: "smooth" });
      }
    }
    var visible = {};
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { visible[en.target.id] = en.isIntersecting; });
      var current = -1;
      for (var k = 0; k < sections.length; k++) if (visible[sections[k].id]) { current = byId[sections[k].id]; break; }
      if (current !== -1) setActive(current);
    }, { rootMargin: "-100px 0px -55% 0px" });
    sections.forEach(function (s) { io.observe(s); });
  }
})();
